/**
 * LegacyHost — wraps a migrated Editorial-desk panel inside the dark
 * OS shell. The panel itself keeps its original cream/brass styling
 * so we don't rewrite 11 panels in this phase; only the chrome (left
 * sidebar + topbar) is dark.
 *
 * Per Concierge_OS_Admin_Build.md §4·1a:
 *   "Migrate the existing Editorial-desk content into the new shell
 *    so nothing breaks."
 *
 * Each migrated page passes a Migrated From note so the desk knows
 * exactly which legacy tab they're looking at.
 */
import React from "react";

export default function LegacyHost({ title, migratedFrom, children, testid }) {
  return (
    <div data-testid={testid || "os-legacy-host"}>
      <div className="os-pagehead">
        <h1>{title}</h1>
        {migratedFrom && (
          <span className="count">migrated from · {migratedFrom}</span>
        )}
      </div>
      <div className="os-legacy-host">{children}</div>
    </div>
  );
}
